// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, LitElement } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property } from 'lit/decorators.js';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import LightElement from './light-element.js';

@customElement('product-price')
export default class ProductPrice extends LightElement {

	@property({ type: Boolean })
	hideRrp: boolean;

	@property({ type: Boolean })
	isTradeCustomer: boolean;

	@property({ type: Boolean })
	showSaleWasPrice: boolean;

	@property({ type: String })
	rrp: string;

	@property({ type: String })
	retailPrice: string;

	@property({ type: String })
	wasPrice: string;

	@property({ type: Boolean })
	hasVariants: boolean;

	@property({ type: String })
	price: string;

	@property({ type: String })
	testRrp = "product-price-rrp";

	@property({ type: String })
	testRetailPrice = "product-retail-price";

	@property({ type: String })
	testWasPrice = "product-price-was";

	@property({ type: String })
	testPrice = "price";

	@property({ type: String })
	testPriceForm = "product-price-from";

	render() {

		return html` 
			<div class="c-price ${this.isTradeCustomer ? "c-price--trade": ""}">
				<div class="c-price__comparison-was-container">
				${this.isTradeCustomer ?
					html`
					<span class="c-price__comparison ${this.showSaleWasPrice ? 'c-price__comparison--by-was' : ''}" data-test="${this.testRetailPrice}">
						Retail ${unsafeHTML(this.retailPrice)}
					</span>
					`
					:
					!this.hideRrp ?
					html`
					<span class="c-price__comparison ${this.showSaleWasPrice ? 'c-price__comparison--by-was' : ''}" data-test="${this.testRrp}">
						<abbr title="Recommended Retail Price">RRP</abbr> ${unsafeHTML(this.rrp)}
					</span>
					`
					: null
					}
					${this.showSaleWasPrice ?
						html`
					<span class="c-price__was" data-test="${this.testWasPrice}">Was <span class="c-price__was-price">${unsafeHTML(this.wasPrice)}</span></span>
					`
					: null}
				</div>
				<p class="c-price__main ${this.showSaleWasPrice ? 'c-price__main--sale' : ''}">
				${this.hasVariants ?
					html`<span class="c-price__main__from" data-test="${this.testPriceForm}">${this.isTradeCustomer ? html`<span class="c-price__main__from__trade-prefix">Trade</span> from` : 'From'}</span>`
					: null}
					${this.isTradeCustomer && !this.hasVariants ?
						html`<span class="c-price__main__trade-prefix">Trade</span>`
						: ''}
					<span data-test="${this.testPrice}">${unsafeHTML(this.price)}</span>
				</p>
			</div>
		`;

	}

}
